import { render, staticRenderFns } from "./uploadCom.vue?vue&type=template&id=34663f87&scoped=true"
import script from "./uploadCom.vue?vue&type=script&lang=js"
export * from "./uploadCom.vue?vue&type=script&lang=js"
import style0 from "./uploadCom.vue?vue&type=style&index=0&id=34663f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34663f87",
  null
  
)

export default component.exports